import { schAloftPrice, schValueType } from '@aloft/toolkit-shared';

import { z } from 'zod';

export const schReconciliationForm = z.object({
  totalCostToCure: schAloftPrice.optional(),
  opinionOfMarketValue: schAloftPrice.optional(),
  opinionOfAfterRepairValue: schAloftPrice.optional(),
  totalRenovationBudget: schAloftPrice.optional(),
  reconciliationCommentary: z.string().optional(),
  highestAndBestUseCommentary: z.string().optional(),
  revisionCommentary: z.string().optional(),
  alternativeComparablesCommentary: z.array(z.string()).optional(),
  feasibilityCommentary: z.string().optional(),
  valueTypes: z.array(schValueType).optional(),
});
export type ReconciliationFormOutput = z.infer<typeof schReconciliationForm>;
export type ReconciliationForm = typeof schReconciliationForm;
